import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { getSettlementCheckStatus } from 'services/fund/settlement'

export default function useGetCheckStatus(
    setIsOpenCashinModal: React.Dispatch<React.SetStateAction<boolean>>,
    setCashinAmount: React.Dispatch<React.SetStateAction<number>>
) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IGetSettlementCheckStatusPayload) => {
            return getSettlementCheckStatus(payload)
        },
        onSuccess: (data, variable) => {
            if (data.to_cashin_amount > 0 || data.to_cashout_amount > 0) {
                setCashinAmount(data.to_cashin_amount)
                setIsOpenCashinModal(true)
            }
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
